var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 pt-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-16 mb-md-32" }, [
        _vm._v(_vm._s(_vm.translations.participant_amount_popup.title))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-32" }, [
        _vm._v(_vm._s(_vm.translations.participant_amount_popup.description))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center format-row mb-32" }, [
        _c(
          "a",
          {
            staticClass: "mr-24",
            class: {
              active: _vm.format === "exact",
              "pl-0": _vm.format !== "exact"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.setFormat("exact")
              }
            }
          },
          [
            _vm._v(
              _vm._s(_vm.translations.participant_amount_popup.exact_amount)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            class: { active: _vm.format === "estimate" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.setFormat("estimate")
              }
            }
          },
          [_vm._v(_vm._s(_vm.translations.participant_amount_popup.estimation))]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-32" },
        [
          _vm.format === "exact"
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "number-wrapper d-flex justify-content-start align-items-center"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "decrease mr-16",
                        on: { click: _vm.decreaseParticipants }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "10"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#efefef",
                                d: "M5 10A5 5 0 105 0a5 5 0 000 10z"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.1 4.6a.4.4 0 01.08.792L7.1 5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6z"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ValidationProvider",
                      {
                        ref: "provider",
                        staticClass: "w-100",
                        attrs: {
                          vid: "amount_of_persons",
                          name:
                            _vm.translations.participant_amount_popup
                              .amount_of_persons,
                          rules: "required|integer|min:1",
                          tag: "div"
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.exact_value,
                              expression: "exact_value"
                            }
                          ],
                          staticClass: "text-center",
                          attrs: {
                            type: "number",
                            id: "amount_of_persons",
                            min: "1",
                            name: "amount_of_persons"
                          },
                          domProps: { value: _vm.exact_value },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.exact_value = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "increase ml-16",
                        on: { click: _vm.increaseParticipants }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "10",
                              height: "10"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#efefef",
                                d: "M5 10A5 5 0 105 0a5 5 0 000 10z"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                d:
                                  "M5 2.5a.4.4 0 01.392.32l.008.08v1.7h1.7a.4.4 0 01.08.792L7.1 5.4H5.4v1.7a.4.4 0 01-.792.08L4.6 7.1V5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6h1.7V2.9c0-.22.18-.4.4-.4z"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.format === "estimate"
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center"
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "d-inline-block mr-16 slider-label" },
                      [
                        _vm._v(
                          _vm._s(_vm.slider_range[0]) +
                            " - " +
                            _vm._s(_vm.slider_range[1]) +
                            _vm._s(_vm.slider_range[1] == 300 ? "+" : "")
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.translations.participant_amount_popup.persons
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "d-inline-block" }),
                _vm._v(" "),
                _c("vue-slider", {
                  attrs: {
                    "dot-size": 24,
                    "tooltip-formatter": _vm.tooltipFormat,
                    interval: 5,
                    min: 0,
                    max: 300
                  },
                  model: {
                    value: _vm.slider_range,
                    callback: function($$v) {
                      _vm.slider_range = $$v
                    },
                    expression: "slider_range"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "popup-footer d-flex align-items-center" }, [
        _c("button", {
          staticClass: "btn btn-accent btn-sm-100 text-white",
          domProps: {
            innerHTML: _vm._s(_vm.translations.participant_amount_popup.select)
          },
          on: { click: _vm.submit }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }